import { IStoreEntityStateSlice, createEntitySlice } from '@aston/foundation';
import { IFederationForm, IFederationListItem } from 'apps/console/src/app/federations-module/models';

export interface IFederationsState {
	federations: IStoreEntityStateSlice<IFederationListItem[]>;
	hasPendingItems: boolean;
	hasLoadedOnce: boolean;
	form: IStoreEntityStateSlice<IFederationForm>;
}

export const initialState: IFederationsState = {
	hasPendingItems: false,
	hasLoadedOnce: false,
	federations: createEntitySlice({ entity: [] }),
	form: createEntitySlice(),
};
